"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeSocialLink1Schema = void 0;
exports.YoutubeSocialLink1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/youtube-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "YoutubeSocialLink1",
    "description": "Add a link to a Youtube channel",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:youtube-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "channelId": {
                    "type": "string",
                    "description": "The ID of a Youtube channel",
                    "pattern": "^[a-zA-Z0-9_\\-]{3,24}$"
                }
            },
            "required": [
                "channelId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy95b3V0dWJlLXNvY2lhbGxpbmsvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxLQUFLLEVBQUUsdUZBQXVGO0lBQzlGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLG9CQUFvQjtJQUM3QixhQUFhLEVBQUUsaUNBQWlDO0lBQ2hELE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiwrQ0FBK0M7YUFDaEQ7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixXQUFXLEVBQUU7b0JBQ1gsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSw2QkFBNkI7b0JBQzVDLFNBQVMsRUFBRSx5QkFBeUI7aUJBQ3JDO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsV0FBVzthQUNaO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=